import { XCircle, ArrowLeft } from 'lucide-react';

export default function MonitoringCancelPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-primary/5 to-white flex items-center justify-center p-4">
      <div
        className="bg-white border border-border rounded-2xl shadow-lg max-w-lg w-full p-8 text-center space-y-4"
        data-testid="monitoring-cancel-page"
      >
        <div className="w-16 h-16 mx-auto rounded-full bg-slate-100 flex items-center justify-center">
          <XCircle className="w-10 h-10 text-slate-500" />
        </div>
        <h1 className="text-2xl font-semibold text-foreground">Monitoring niet gestart</h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          U heeft de Stripe-betaling afgebroken. Er is niets in rekening gebracht.
        </p>
        <p className="text-xs text-muted-foreground">
          U kunt de monitoring op elk moment alsnog starten via de starter-kit, of advies vragen
          zonder abonnement.
        </p>
        <div className="flex flex-col gap-2 pt-2">
          <a
            href="/energy-control-intake"
            className="w-full inline-flex items-center justify-center gap-1 px-4 py-3 rounded-md bg-primary text-white text-sm font-semibold hover:bg-primary/90"
            data-testid="monitoring-cancel-retry"
          >
            Probeer opnieuw — € 9,95/m eerste 3 mnd
          </a>
          <div className="flex gap-2 justify-center">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-1 px-4 py-2 rounded-md border border-border text-sm font-semibold hover:bg-muted"
              data-testid="monitoring-cancel-back"
            >
              <ArrowLeft className="w-4 h-4" /> Terug
            </button>
            <a
              href="/"
              className="inline-flex items-center gap-1 px-4 py-2 rounded-md border border-border text-foreground text-sm font-semibold hover:bg-muted"
              data-testid="monitoring-cancel-home"
            >
              Naar home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
